var reachedEndState = false;
var experimentTimeoutLimit = 6 * 60*60 * 1000; // 6 hours

var consortEvents = {
    STARTED: 'userStartedExperiment',
    STARTED_CONSENT: 'userStartedConsent',
    PASSED_CONSENT: 'userPassedConsent',
    FAILED_CONSENT: 'userFailedConsent',
    STARTED_SCREENOUT: 'userStartedScreenout',
    PASSED_SCREENOUT: 'userPassedScreenout',
    FAILED_SCREENOUT: 'userFailedScreenout',
    STARTED_TRIAL: 'userStartedTrial',
    DROPPED: 'userDroppedExperiment',
    TIMEOUT: 'userExperimentTimeout', //will be triggered by backend most likely
    FINISHED: 'userFinishedExperiment',
    REDIRECTED: 'userRedirected',
}

function timeoutExperiemnt() {
    if (window.inPreviewMode || window.reachedEndState) {
        return;
    }

    window.disableResponses();
    window.clearTimeouts();
    window.reachedEndState = true;
    window.changeDesignDefault();
    window.hideAll();
    document.getElementById('consentScreen').style.display = "none"
    let timeoutTextContent = trans('timeout.text');
    displayText('content', timeoutTextContent);
    throw new Error("Experiment timed out!"); // to stop executing any other code after timeoutExperiment is called
}

function logExperimentEvent(eventName) {
    console.log('logExperimentEvent', eventName);
    const endStates = [
        consortEvents.FAILED_CONSENT,
        consortEvents.FAILED_SCREENOUT,
        consortEvents.FINISHED,
        consortEvents.DROPPED,
        consortEvents.REDIRECTED,
    ];


    if (!window.logConsort || window.inPreviewMode || window.reachedEndState) {
        return;
    }

    if(endStates.indexOf(eventName) >= 0) {
        window.reachedEndState = true;
    }

    try {
        let url = document.URL;
        url = url.substring(0, url.lastIndexOf("/")) + "/handleExperimentEvent";
        var fd = new FormData();
        fd.set('event', eventName);
        fd.set('start', window.startTimestamp);
        if(window.pickedSubjectGroups && window.pickedSubjectGroups.length > 0) {
            fd.set('subject_group', JSON.stringify(window.pickedSubjectGroups));
        } else {
            fd.set('subject_group', JSON.stringify(['nsg:No Group']));
        }

        if(window.trialRow) {
            fd.set('last_trial', computeRowNo(window.trialRow));
            const label = window.columnForTrial('label', window.trialRow);
                fd.set('last_trial_label', label == 'na' ? '' : label);
        }
        var beaconSuccess = navigator.sendBeacon(url, fd);
        console.log('logExperimentEvent', url + "/handleExperimentEvent", beaconSuccess, fd);
    } catch (error) {
        console.error('Failed to log event', eventName, error);
        Bugsnag && Bugsnag.leaveBreadcrumb('[consort][logExperimentEvent] Failed to log event', {event: eventName}, 'state');
        Bugsnag && Bugsnag.notify(error);
    }
}